import { isContactLensesBundleOrderLineItem, isGlassesBundleOrderLineItem, isNonPrescriptionBundleOrderLineItem } from '../mappers/view/utils/order-line-item-product-type-guards.js';

/**
 * On 31/05/2022 My Account Team (@yannickbuntsma, @sergesi, etc.) had a meeting about reordering different product types.
 * Decision has been taken (and reinforced upon): reordering as a feature does not work for "complex" line item types.
 * This includes:
 * - ContactLensesBundleOrderLineItem
 * - PrescriptionGlassesBundleOrderLineItem
 * - NonPrescriptionGlassesBundleOrderLineItem
 */ const isLineItemReorderable = (orderLineItem)=>{
    var ref;
    return !!((ref = orderLineItem.product.currentProduct) === null || ref === void 0 ? void 0 : ref.published) && !isContactLensesBundleOrderLineItem(orderLineItem) && !isGlassesBundleOrderLineItem(orderLineItem) && !isNonPrescriptionBundleOrderLineItem(orderLineItem);
};
// Determines if the reorder functionality of an order is enabled
const isEveryLineItemReorderable = (orderLineItem)=>orderLineItem.every((i)=>isLineItemReorderable(i)
    )
;

export { isEveryLineItemReorderable, isLineItemReorderable };
//# sourceMappingURL=is-line-item-reorderable.js.map
